module.exports = __webpack_public_path__ + "img/qrokant_logo_small_invert.f3fb12a6.png";